

 
<div class="padding">
    <div class="top-right mb-15">
        <span class="font-color" *ngIf="selected === 'employeeWise'">
            Differ History By Employees
        </span>
        <div class="toggle">
            <mat-slide-toggle class="slide-toggle" color="primary" [checked]="isGraphView" (change)="getdata($event)">
              <label class="fw-500 pt-3">Graph View</label>
            </mat-slide-toggle>
          </div>
    </div>
   
        <div class="top-right mb-15">
        <span class="font-color" *ngIf="selected === 'projectWise'">Differ History By Projects</span>
        <div class="top-right mb-15" *ngIf="selected === 'employeeWise'">
            <div class="labels">Enter a date range</div>
            <mat-form-field class="custom_select_checkbox_chips custom_date_picker" appearance="outline">
                <!-- <mat-label>Enter a date range</mat-label> -->
                <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" [(ngModel)]="startDate">
                    <input matEndDate placeholder="End date" [(ngModel)]="endDate">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="rangePicker" class="mt-2"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>Cancel</button>
                        <button mat-raised-button color="primary" (click)="applyDateFilter()"
                            matDateRangePickerApply>Apply</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
 
        </div>
   
 
 
     
 
 
   
        <div class="top-right-end mb-15">
         <div class="select-filter" >
             <mat-form-field appearance="fill" class="custom_select">
                 <mat-select [(ngModel)]="selected">
                   <mat-option value="employeeWise">By Employee</mat-option>
                   <mat-option value="projectWise">By project</mat-option>
                 </mat-select>
             </mat-form-field>
             <div class="space-align">          
                <button class="custom_btn primary_btn_base d-flex align-items-center add_proposal_btn" (click)="exportData()" >Export</button>
            </div>
         </div>
        </div>
 
     
        <!-- <select [(ngModel)]="selected">
            <option value="employeeWise">By Employee</option>
            <option value="projectWise">By project</option>
        </select> -->
    </div>
    <div *ngIf="selected === 'employeeWise'">
        <div *ngIf="!isGraphView">
            <mat-table [dataSource]="dataSource">
                <ng-container  matColumnDef="EmployeeId">
                    <mat-header-cell *matHeaderCellDef class="text-center"> Employee Id </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row?.EmployeeId }} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="EmployeeName">
                    <mat-header-cell *matHeaderCellDef class="text-center"> Employee Name </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row?.EmployeeName }} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="ProjectName">
                    <mat-header-cell *matHeaderCellDef class="text-center">Project Name </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row?.ProjectName }} </mat-cell>
                </ng-container>
                <ng-container  matColumnDef="ManagerName">
                    <mat-header-cell *matHeaderCellDef class="text-center"> Manager Name </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row?.ManagerName }} </mat-cell>
                </ng-container>
                <ng-container  matColumnDef="DifferDates">
                    <mat-header-cell *matHeaderCellDef class="text-center"> Differ Dates </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row?.DifferDates }} </mat-cell>
                </ng-container>
                <ng-container  matColumnDef="Count">
                    <mat-header-cell *matHeaderCellDef class="text-center"> Count </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row?.Count }} </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
            <div *ngIf="!(totalEmployeeCount>0)" class="no-records">
                No records.(Development in progress)
            </div>
        </div>
        <div *ngIf="isGraphView">
            <div id="chartContainer"></div>
        </div>
    </div>
   
    <div *ngIf="selected === 'projectWise'">
        <mat-table [dataSource]="dataSource1">
            <ng-container  matColumnDef="ProjectName">
                <mat-header-cell *matHeaderCellDef class="text-center"> Project Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row?.ProjectName }} </mat-cell>
            </ng-container>
            <ng-container  matColumnDef="ManagerName">
                <mat-header-cell *matHeaderCellDef class="text-center"> Manager Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row?.ManagerName }} </mat-cell>
            </ng-container>
            <ng-container  matColumnDef="Count">
                <mat-header-cell *matHeaderCellDef class="text-center"> Count </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row?.Count }} </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumnsProjectWise"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumnsProjectWise;"></mat-row>
        </mat-table>
        <div *ngIf="!(totalProjectCount>0)" class="no-records">
            No records
        </div>
    </div>
 
    <div >
        <button class="close-button custom_btn inverted_btn_base " (click)="closeDialog()">Close</button>
    </div>
 
</div>
<!-- <div id="chartContainer"> </div> -->
 
 